import { fork, put, takeLatest, takeEvery, all, select, call } from 'redux-saga/effects';
import apiClient from '../../../../utils/apiClient';
import * as selectors from '../containers/selectors';

import {
    GET_SELECTED_BUNDLE_INFO_URL,
    GET_SABDV_URL,
    GET_FIOS_INTERNET_DATA_URL,
    GET_BASIC_INTERNET_DATA_URL,
    GET_FIOS_TV_URL,
    GET_SELECTED_FLEX_BUNDLE_INFO_URL,
    UPDATE_FIOS_INTERNET_DATA_URL,
    POST_UPDATE_BUNDLE,
    POST_UPDATE_NON_BUNDLE,
    UPDATE_BASIC_INTERNET_DATA_URL,
    UPDATE_BDV_URL,
    GET_SELECTED_BDV_BUNDLE_INFO_URL,
    UPDATE_FIOS_TV_URL,
    UPDATE_SERVICES_REQ_CALL_INFO
} from '../../../../containers/APIurls';
import {
    BUNDLE, UPDATEFOR, FLOW, getSelectedDataBundleURL,
    formFiosDataBDVTVBundleInfoRequestPayload,
    formFiosDataStandardPhoneTVBundleInfoRequestPayload,
    formFiosDataBDVBundleInfoRequestPayload,
    formFiosDataPhoneBundleInfoRequestPayload
} from '../../../../containers/bundleConversionUtils';
import { updateCartAsynchronously } from '../../../../containers/sagas';
import { getFloatingCartDetails } from '../../../../containers/bundleConversionSaga';

/* Headers */
const HeadersForFormData = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
};

function* switchContractAgreement(params) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });

    let { contractTerm } = params;
    contractTerm = contractTerm === "No annual contract" ? "MonthToMonth" : "TwoYears";

    const allFlowRequestPayLoads = yield select(selectors.allFlowRequestPayLoads);
    const getNonDoFlowRes = {};
    const allSelectedPlans = yield select(selectors.allSelectedPlans);
    const allSelectedNonDoBundlePlans = yield select(selectors.allSelectedNonDoBundlePlans);
    const servicesInCart = yield select(selectors.servicesInCart);
    const internetProductsInCart = yield select(selectors.internetProductsInCart);
    const bdvProductsInCart = yield select(selectors.bdvProductsInCart);
    const voiceProductsInCart = yield select(selectors.voiceProductsInCart);
    const selectedPremiumSupportPlans = yield select(selectors.selectedPremiumSupportPlans);

    if (servicesInCart === BUNDLE.DATA || servicesInCart === BUNDLE.HSI) {
        let InternetType = "", GET_INTERNET_URL = "", UPDATE_INTERNET_URL = "";
        if (servicesInCart === BUNDLE.DATA) {
            InternetType = UPDATEFOR.STANDALONE_DATA;
            GET_INTERNET_URL = GET_FIOS_INTERNET_DATA_URL;
            UPDATE_INTERNET_URL = UPDATE_FIOS_INTERNET_DATA_URL;
        } else {
            InternetType = UPDATEFOR.STANDALONE_HSI;
            GET_INTERNET_URL = GET_BASIC_INTERNET_DATA_URL;
            UPDATE_INTERNET_URL = UPDATE_BASIC_INTERNET_DATA_URL;
        }

        const newSelection = yield call(getNewSelectionForInternet, allSelectedPlans, InternetType,
            getNonDoFlowRes, contractTerm);

        console.log("newSelection", newSelection[0]);
        console.log("Updated allSelectedPlans", allSelectedPlans);

        let params = {};

        if (newSelection?.length > 0) {
            params = {
                bundleID: newSelection[0].BID,
                tvID: 0,
                nLines: 1,
                contract: contractTerm,
                hcid: newSelection[0].Services[0]?.ID,
                ptype: newSelection[0].Services[0]?.ServiceType,
                bRc: newSelection[0].BundleRC,
                upselSelected: false
            };
        }

        const formParams = constructFormParams(params);

        const response = yield call(selectedBundleInfo, formParams);

        if (response !== "Fail") {
            yield call(getNewPlansForInternet, GET_INTERNET_URL);
            yield call(updateSelectedPlansForInternet, UPDATE_INTERNET_URL, allFlowRequestPayLoads, InternetType, newSelection, servicesInCart, internetProductsInCart);
            yield put({ type: "UPDATE_INTERNET_PLAN_ID", internetPlanID: params?.hcid?.toString() });
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }
    } else if (servicesInCart === BUNDLE.VIDEO) {

        const userSelectedBundleInfo = yield select(selectors.selectedBundleInfoRequestBodyForTv);
        const tvProductsInCart = yield select(selectors.tvProductsInCart);

        const tvInfo = getNonDoFlowRes?.TVInfo?.filter(product => product?.Services[0]?.ID === userSelectedBundleInfo?.hcid);

        const priceArray = tvInfo && tvInfo?.length > 0 ? tvInfo[0]?.sTVDiscount?.split(",") : [];

        const params = {
            bundleID: userSelectedBundleInfo?.bundleID,
            tvID: 0,
            nLines: 1,
            contract: contractTerm,
            hcid: userSelectedBundleInfo?.hcid,
            ptype: 'TV',
            bRc: priceArray?.length > 1 ? contractTerm === "TwoYears" ? priceArray[1] : priceArray[0] : 0,
            upselSelected: false
        };

        const formParams = constructFormParams(params);

        const response = yield call(selectedBundleInfo, formParams);

        if (response !== "Fail") {
            yield call(getNewPlansForTV, GET_FIOS_TV_URL + "?type=standalone_tv");
            yield call(updateSelectedPlansForTv, UPDATE_FIOS_TV_URL, allFlowRequestPayLoads, tvProductsInCart);
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }
    } else if (servicesInCart === BUNDLE.BDV) {

        const newSelection = getNonDoFlowRes?.BDV?.filter(product => product.Contract === contractTerm);

        const response = yield call(getSABDV, newSelection, contractTerm);

        if (response !== "Fail") {
            yield call(updateSelectedPlansForBDV, UPDATE_BDV_URL, allFlowRequestPayLoads, bdvProductsInCart, newSelection);
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }

    } else if (servicesInCart === BUNDLE.BDV_DATA_VIDEO) {
        let tripleBDVInternetType = "", TRIPLE_GET_FIOS_INTERNET_URL = "", TRIPLE_UPDATE_BDV_URL = "", TRIPLE_GET_FIOS_VIDEO_URL = '', TRIPLE_GET_BDV_URL = '';
        tripleBDVInternetType = UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_BDV + '+' + UPDATEFOR.TRIPLE_VIDEO;
        TRIPLE_GET_FIOS_INTERNET_URL = GET_FIOS_INTERNET_DATA_URL;
        TRIPLE_GET_FIOS_VIDEO_URL = GET_FIOS_TV_URL;
        TRIPLE_UPDATE_BDV_URL = POST_UPDATE_BUNDLE;
        const newSelection = yield call(getPlanForTripleBundleBasedOnContract, servicesInCart,
            allSelectedNonDoBundlePlans, tripleBDVInternetType, getNonDoFlowRes, contractTerm, BUNDLE.BDV);
        console.log("newSelection", newSelection[0]);
        console.log("Updated allSelectedPlans", allSelectedPlans);
        const response = yield call(selectedTripleBDVBundleInfo, newSelection, contractTerm);
        if (response !== "Fail") {
            yield call(getNewPlansForInternet, TRIPLE_GET_FIOS_INTERNET_URL);
            yield call(getNewPlansForTV, TRIPLE_GET_FIOS_VIDEO_URL);
            yield call(updateSelectedPlansForBDVTriple, TRIPLE_UPDATE_BDV_URL, allFlowRequestPayLoads, tripleBDVInternetType, newSelection, servicesInCart, internetProductsInCart, selectedPremiumSupportPlans);
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }


    } else if (servicesInCart === BUNDLE.PHONE_DATA_VIDEO) {
        let tripleStandardPhoneInternetType = "", TRIPLE_GET_FIOS_INTERNET_URL = "", TRIPLE_UPDATE_PHONE_URL = "", TRIPLE_GET_FIOS_VIDEO_URL = '', TRIPLE_GET_STANDARD_PHONE_URL = '';
        tripleStandardPhoneInternetType = UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_PHONE + '+' + UPDATEFOR.TRIPLE_VIDEO;
        TRIPLE_GET_FIOS_INTERNET_URL = GET_FIOS_INTERNET_DATA_URL;
        TRIPLE_GET_FIOS_VIDEO_URL = GET_FIOS_TV_URL;
        TRIPLE_UPDATE_PHONE_URL = POST_UPDATE_BUNDLE;
        const newSelection = yield call(getPlanForTripleBundleBasedOnContract, servicesInCart, allSelectedNonDoBundlePlans, tripleStandardPhoneInternetType, getNonDoFlowRes, contractTerm, BUNDLE.PHONE);
        console.log("newSelection", newSelection[0]);
        console.log("Updated allSelectedNonDoBundlePlans", allSelectedNonDoBundlePlans);
        const response = yield call(selectedTripleStandardPhoneBundleInfo, newSelection, contractTerm);
        if (response !== "Fail") {
            yield call(getNewPlansForPhone, TRIPLE_GET_STANDARD_PHONE_URL);
            yield call(getNewPlansForInternet, TRIPLE_GET_FIOS_INTERNET_URL);
            yield call(getNewPlansForTV, TRIPLE_GET_FIOS_VIDEO_URL);
            yield call(updateSelectedPlansForStandardPhoneTriple, TRIPLE_UPDATE_PHONE_URL, allFlowRequestPayLoads, tripleStandardPhoneInternetType, newSelection, servicesInCart, internetProductsInCart, voiceProductsInCart, selectedPremiumSupportPlans);
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }
    } else if (servicesInCart === BUNDLE.DATA_BDV || servicesInCart === BUNDLE.BDV_DATA) {
        let servicesInCart1 = servicesInCart === BUNDLE.BDV_DATA ? BUNDLE.DATA_BDV : BUNDLE.DATA_BDV;
        let doubleBDVInternetType = UPDATEFOR.DOUBLE_DATA + '+' + UPDATEFOR.DOUBLE_BDV;
        let DOUBLE_GET_FIOS_INTERNET_URL = GET_FIOS_INTERNET_DATA_URL;
        let DOUBLE_UPDATE_BDV_URL = POST_UPDATE_BUNDLE;

        const newSelection = yield call(getPlanForDoubleBundleBasedOnContract, servicesInCart1,
            allSelectedNonDoBundlePlans, doubleBDVInternetType, getNonDoFlowRes, contractTerm, BUNDLE.BDV);
        const response = yield call(selectedDoubleBDVBundleInfo, newSelection, contractTerm);
        if (response !== "Fail") {
            yield call(getNewPlansForInternet, DOUBLE_GET_FIOS_INTERNET_URL);
            yield call(updateSelectedPlansForBDVDouble, DOUBLE_UPDATE_BDV_URL, allFlowRequestPayLoads,
                doubleBDVInternetType, newSelection, servicesInCart1, internetProductsInCart);
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }
    }
    else if (servicesInCart === (BUNDLE.DATA_PHONE || BUNDLE.PHONE_DATA)) {
        let servicesInCart1 = servicesInCart === BUNDLE.PHONE_DATA ? BUNDLE.PHONE_DATA : BUNDLE.DATA_PHONE;
        let doubleSPInternetType = UPDATEFOR.DOUBLE_PHONE + '+' + UPDATEFOR.DOUBLE_DATA;

        let DOUBLE_GET_FIOS_INTERNET_URL = GET_FIOS_INTERNET_DATA_URL;
        let DOUBLE_UPDATE_SP_URL = POST_UPDATE_BUNDLE;
        const newSelection = yield call(getPlanForDoubleBundleBasedOnContract, servicesInCart1,
            allSelectedNonDoBundlePlans, doubleSPInternetType, getNonDoFlowRes, contractTerm, BUNDLE.PHONE);

        const response = yield call(selectedDoubleStandardPhoneBundleInfo, newSelection, contractTerm);
        if (response !== "Fail") {
            yield call(getNewPlansForInternet, DOUBLE_GET_FIOS_INTERNET_URL);
            yield call(updateSelectedPlansForStandardPhoneDouble, DOUBLE_UPDATE_SP_URL,
                allFlowRequestPayLoads, doubleSPInternetType, newSelection,
                servicesInCart1, selectedPremiumSupportPlans);
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }

    } else if (servicesInCart === BUNDLE.HSI_PHONE || servicesInCart === BUNDLE.PHONE_HSI) {

        let servicesInCart1 = servicesInCart === BUNDLE.PHONE_HSI ?
            BUNDLE.HSI_PHONE : BUNDLE.HSI_PHONE;

        let doubleSPInternetType = UPDATEFOR.DOUBLE_PHONE + '+' + UPDATEFOR.DOUBLE_DATA;

        let DOUBLE_UPDATE_SP_URL = POST_UPDATE_BUNDLE;
        let DOUBLE_GET_INTERNET_URL = GET_BASIC_INTERNET_DATA_URL;

        const newSelection = yield call(getPlanForDoubleBundleBasedOnContract, servicesInCart1,
            allSelectedNonDoBundlePlans, doubleSPInternetType, getNonDoFlowRes, contractTerm, BUNDLE.PHONE);

        const response = yield call(selectedDoubleStandardPhoneBundleInfo, newSelection, contractTerm);
        if (response !== "Fail") {
            yield call(getNewPlansForInternet, DOUBLE_GET_INTERNET_URL);
            yield call(updateSelectedPlansForStandardPhoneDouble, DOUBLE_UPDATE_SP_URL,
                allFlowRequestPayLoads, doubleSPInternetType, newSelection,
                servicesInCart1, selectedPremiumSupportPlans);
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }

    }
    else if (servicesInCart === (BUNDLE.FLEX || BUNDLE.REVERSE_FLEX)) {

        let flexInternetType = UPDATEFOR.DOUBLE_DATA + UPDATEFOR.DOUBLE_VIDEO;
        let UPDATE_FLEX_URL = POST_UPDATE_NON_BUNDLE;

        const newSelection = yield call(getPlanForDoubleBundleBasedOnContract, servicesInCart, allSelectedNonDoBundlePlans, flexInternetType, getNonDoFlowRes, contractTerm, BUNDLE.VIDEO);

        let params = {};

        if (newSelection?.length > 0) {
            params = {
                "BID": newSelection[0].BID,
                "dHCID": newSelection[0].SpeedHCID,
                "dPAKGID": newSelection[0].SpeedPKGID,
                "TVPackageID": newSelection[0].TVPackagId,
                "TVHCID": newSelection[0].TVHCId,
                "RC": newSelection[0].BundleRC,
                "contract": contractTerm
            };
            const response = yield call(getFlexSelection, newSelection, GET_SELECTED_FLEX_BUNDLE_INFO_URL, params);
            if (response !== "Fail") {
                yield call(getNewPlansForInternet, GET_FIOS_INTERNET_DATA_URL);
                yield call(getNewPlansForTV, GET_FIOS_TV_URL + "?type=standalone_tv");
                yield call(updateSelectedPlansForFlexBundle, UPDATE_FLEX_URL,
                    allFlowRequestPayLoads, flexInternetType, newSelection, servicesInCart, selectedPremiumSupportPlans, internetProductsInCart);
            } else {
                yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
                yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
            }
        } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        }
    }

    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield fork(updateCartAsynchronously);
}

function* getFlexSelection(newSelection, GET_SELECTED_FLEX_BUNDLE_INFO_URL, params, HeadersForFormData) {

    const formParams = constructFormParams(params);

    try {
        const response = yield apiClient.post(GET_SELECTED_FLEX_BUNDLE_INFO_URL, formParams, HeadersForFormData);
        yield put({ type: "UPDATE_ALL_SELECTED_NON_DO_BUNDLE_PLANS_INFO", params: { id: BUNDLE.FLEX, selectedPlans: formParams } });
        yield put({ type: "SET_SELECTED_NON_DO_BUNDLE_PLANS", params: { id: BUNDLE.FLEX, selectedPlans: newSelection[0] } });
        return response.data;
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* updateSelectedPlansForBDV(UPDATE_BDV_URL, allFlowRequestPayLoads, bdvProductsInCart, newSelection) {

    const requestPayload = allFlowRequestPayLoads?.filter(payload => payload.id === UPDATEFOR.STANDALONE_BDV);

    let requestPayloadForBDV = {};

    if (bdvProductsInCart && requestPayload?.length > 0) {

        let BDVPhoneLines = {};

        if (newSelection?.length > 0) {
            BDVPhoneLines = requestPayload[0].selectedPlans?.BdvPhoneLines?.map(line => {

                if (line?.LineNO === 1) {
                    line.NewPlanID = newSelection[0].BID?.toString();
                    line.OldPlanID = newSelection[0].BID?.toString();
                } else {
                    line.NewPlanID = newSelection[0].BID?.toString();
                    line.OldPlanID = "0";
                }

                return line;
            });
        }

        requestPayloadForBDV = {
            "addedbuttonSelectionBDV": requestPayload[0].selectedPlans?.addedbuttonSelectionBDV,
            "BdvBundleSelection": requestPayload[0].selectedPlans?.BdvBundleSelection,
            "BdvDirListing": bdvProductsInCart.BdvDirListing,
            "BdvGlobalValues": requestPayload[0].selectedPlans?.BdvGlobalValues,
            "BdvJacks": requestPayload[0].selectedPlans?.BdvJacks,
            "BdvListingInfo": requestPayload[0].selectedPlans?.BdvListingInfo,
            "BdvMaintenance": requestPayload[0].selectedPlans?.BdvMaintenance,
            "BdvPhoneLines": BDVPhoneLines,
            "BdvProviderInfo": {},
            "EquipMapping": bdvProductsInCart.EquipMapping,
            "FaxJacks": [],
            "FaxLines": bdvProductsInCart.FaxLines ? bdvProductsInCart.FaxLines : []
        };
    }

    try {
        yield apiClient.post(UPDATE_BDV_URL, requestPayloadForBDV);
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* updateSelectedPlansForTv(UPDATE_FIOS_TV_URL, allFlowRequestPayLoads, tvProductsInCart) {

    const requestPayload = allFlowRequestPayLoads.filter(flow => flow.id === UPDATEFOR.STANDALONE_VIDEO);

    let requestPayloadForTv = {};

    if (requestPayload?.length > 0) {

        requestPayloadForTv = {
            "addedbuttonSelectionTV": requestPayload[0]?.selectedPlans?.addedbuttonSelectionTV,
            "CustomCHSelection": [],
            "InternationalSelection": tvProductsInCart?.InternationalSelection ? tvProductsInCart?.InternationalSelection : [],
            "MovieSelection": tvProductsInCart?.MovieSelection ? tvProductsInCart?.MovieSelection : [],
            "PeopleCount": "",
            "PlanSelection": tvProductsInCart?.PlanSelection ? tvProductsInCart?.PlanSelection : {},
            "QNDone": requestPayload[0]?.selectedPlans?.QNDone,
            "RecordShow": requestPayload[0]?.selectedPlans?.RecordShow,
            "RouterSelection": tvProductsInCart?.RouterSelection ? tvProductsInCart?.RouterSelection : {},
            "SatelliteOrDish": requestPayload[0]?.selectedPlans?.SatelliteOrDish ? requestPayload[0]?.selectedPlans?.SatelliteOrDish : "NA",
            "SelectedEquipments": tvProductsInCart?.SelectedEquipments ? tvProductsInCart?.SelectedEquipments : [],
            "SpecialitySelection": tvProductsInCart?.SpecialitySelection ? tvProductsInCart?.SpecialitySelection : [],
            "SportsSelection": tvProductsInCart?.SportsSelection ? tvProductsInCart?.SportsSelection : [],
            "TOSAccepted": tvProductsInCart?.TOSAccepted,
            "TOSDone": requestPayload[0]?.selectedPlans?.TOSDone,
            "ViewSelection": tvProductsInCart?.ViewSelection,
            "SelectedPPS": tvProductsInCart?.SelectedPPS ? tvProductsInCart?.SelectedPPS : []
        };
    }

    try {
        yield apiClient.post(UPDATE_FIOS_TV_URL, requestPayloadForTv);
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* getSABDV(newSelection, contractTerm) {

    let params = {};

    if (newSelection?.length > 0) {
        params = {
            bundleID: newSelection[0].BID,
            bRc: newSelection[0].BundleRC,
            Nlines: 1,
            contract: contractTerm
        };
    }

    const formParams = constructFormParams(params);

    try {
        const response = yield apiClient.post(GET_SABDV_URL, formParams, HeadersForFormData);
        return response.data;
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function getSelectedPremiumSupport(servicesInCart, selectedPremiumSupportPlans) {

    const plans = selectedPremiumSupportPlans?.filter(plan => plan?.id === servicesInCart);

    return plans?.length > 0 ? plans[0].selectedPremiumSupport : [];
}

function constructFormParams(params) {

    const formParams = new URLSearchParams();

    Object.keys(params).forEach(key => {
        formParams.append(key, params[key]);
    });

    return formParams;
}


function* getPlanForTripleBundleBasedOnContract(servicesInCart, allSelectedNonDoBundlePlans, InternetType, getNonDoFlowRes, contractTerm, phoneServiceType) {
    const selectedInternetPlans = allSelectedNonDoBundlePlans?.filter(plan => plan?.id === servicesInCart);
    if (selectedInternetPlans && selectedInternetPlans?.length > 0) {
        let newSelection = [];
        if (phoneServiceType === BUNDLE.BDV) {
            newSelection = getNonDoFlowRes?.BDVTP?.filter(product => {
                if (product.Contract === contractTerm &&
                    product.IP === selectedInternetPlans[0].selectedPlans?.IP &&
                    product.UPSPEED === selectedInternetPlans[0].selectedPlans?.UPSPEED) {
                    return product;
                }
            });
        } else {
            newSelection = getNonDoFlowRes?.TPBundleInfo?.filter(product => {
                if (product.Contract === contractTerm &&
                    product.Services[0].IP === selectedInternetPlans[0].selectedPlans?.Services[0].IP &&
                    product.Services[0].UP_SPEED === selectedInternetPlans[0].selectedPlans?.Services[0].UP_SPEED) {
                    return product;
                }
            });
        }

        return newSelection;
    }
}

function* getPlanForDoubleBundleBasedOnContract(servicesInCart, allSelectedNonDoBundlePlans, InternetType, getNonDoFlowRes, contractTerm, serviceType) {
    const selectedInternetPlans = allSelectedNonDoBundlePlans?.filter(plan => plan?.id === servicesInCart);
    if (selectedInternetPlans && selectedInternetPlans?.length > 0) {
        let newSelection = [];
        if (serviceType === BUNDLE.BDV) {
            newSelection = getNonDoFlowRes?.BDVFIOSDP?.filter(product => {
                if (product.Contract === contractTerm &&
                    product.IP === selectedInternetPlans[0].selectedPlans?.IP &&
                    product.UPSPEED === selectedInternetPlans[0].selectedPlans?.UPSPEED) {
                    return product;
                }
            });
        } else if (serviceType === BUNDLE.VIDEO) {
            newSelection = getNonDoFlowRes?.FLEX?.filter(product => {
                if (product.Contract === contractTerm &&
                    product.IP === selectedInternetPlans[0].selectedPlans?.IP &&
                    product.UPSPEED === selectedInternetPlans[0].selectedPlans?.UPSPEED) {
                    return product;
                }
            });
        } else {
            newSelection = getNonDoFlowRes?.HSIBundleInfo?.filter(product => {
                if (product.Contract === contractTerm &&
                    product.Services[0].IP === selectedInternetPlans[0].selectedPlans?.Services[0].IP &&
                    product.Services[0].UP_SPEED === selectedInternetPlans[0].selectedPlans?.Services[0].UP_SPEED) {
                    return product;
                }
            });
        }

        return newSelection;
    }
}

function* getNewSelectionForInternet(allSelectedPlans, InternetType, getNonDoFlowRes, contractTerm) {

    const selectedInternetPlans = allSelectedPlans?.filter(plan => plan?.id === InternetType);

    const selectedInternetSpeed = selectedInternetPlans &&
        selectedInternetPlans?.length > 0 ? selectedInternetPlans[0].selectedPlans.filter(speed => speed && speed?.className === "InternetSpeed") : "";

    const selectedIPType = selectedInternetPlans &&
        selectedInternetPlans?.length > 0 ? selectedInternetPlans[0].selectedPlans.filter(speed => speed && speed?.className === "IpAddress") : "";

    const IPType = selectedIPType[0].selectedDetails?.IPType?.includes("Static") ? "Static" : "Dynamic";

    console.log("selectedInternetSpeed", selectedInternetSpeed);

    if (selectedInternetSpeed && selectedInternetSpeed?.length > 0) {
        const newSelection = getNonDoFlowRes.DataInfo.filter(product => {

            if (product.Contract === contractTerm &&
                product.Services[0].IP === IPType &&
                product.Services[0].UP_SPEED === selectedInternetSpeed[0].selectedDetails?.Services[0].UP_SPEED &&
                product.Services[0].DOWN_SPEED === selectedInternetSpeed[0].selectedDetails?.Services[0].DOWN_SPEED) {
                return product;
            }
        });
        // selectedInternetSpeed[0].selectedDetails = newSelection[0];
        //yield put({ type: "UPDATE_ALL_SELECTED_PLANS", params: { id: UPDATEFOR.STANDALONE_DATA, selectedPlans: selectedInternetPlans[0].selectedPlans } });

        return newSelection;
    }
}

function* selectedBundleInfo(formParams) {

    try {
        const response = yield apiClient.post(GET_SELECTED_BUNDLE_INFO_URL, formParams, HeadersForFormData);
        return response.data;
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}


/** Selected Bundle Info For Triple Bundle */
function* selectedTripleBDVBundleInfo(newSelection, contractTerm) {
    const params = formFiosDataBDVTVBundleInfoRequestPayload(newSelection[0]);
    const formParams = constructFormParams(params);
    const {bdvStatus} = yield select(state=>state.CustomizeOrder.getPostLqData)
    try {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
        if(bdvStatus!==null&&bdvStatus&&(bdvStatus==='Y'||bdvStatus==='y')){
        const response = yield apiClient.post(GET_SELECTED_BDV_BUNDLE_INFO_URL, formParams, HeadersForFormData);
        yield put({ type: "UPDATE_ALL_SELECTED_NON_DO_BUNDLE_PLANS_INFO", params: { id: BUNDLE.BDV_DATA_VIDEO, selectedPlans: formParams } });
        yield put({ type: "SET_SELECTED_NON_DO_BUNDLE_PLANS", params: { id: BUNDLE.BDV_DATA_VIDEO, selectedPlans: newSelection[0] } });
        return response.data;
        }
    } catch (err) {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }finally{
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
}

function* selectedTripleStandardPhoneBundleInfo(newSelection, contractTerm) {
    const params = formFiosDataStandardPhoneTVBundleInfoRequestPayload(newSelection[0]);
    const formParams = constructFormParams(params);
    try {
        const response = yield apiClient.post(GET_SELECTED_BUNDLE_INFO_URL, formParams, HeadersForFormData);
        yield put({ type: "UPDATE_ALL_SELECTED_NON_DO_BUNDLE_PLANS_INFO", params: { id: BUNDLE.PHONE_DATA_VIDEO, selectedPlans: formParams } });
        yield put({ type: "SET_SELECTED_NON_DO_BUNDLE_PLANS", params: { id: BUNDLE.PHONE_DATA_VIDEO, selectedPlans: newSelection[0] } });
        return response.data;
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

/** Selected Bundle Info For Double Bundle */
function* selectedDoubleBDVBundleInfo(newSelection, contractTerm) {
    const params = formFiosDataBDVBundleInfoRequestPayload(newSelection[0])
    const formParams = constructFormParams(params);
    const {bdvStatus} = yield select(state=>state.CustomizeOrder.getPostLqData)

    try {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
        if(bdvStatus!==null&&bdvStatus&&(bdvStatus==='Y'||bdvStatus==='y')){
        const response = yield apiClient.post(GET_SELECTED_BDV_BUNDLE_INFO_URL, formParams, HeadersForFormData);
        return response.data;
        }
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }finally{
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
}

function* selectedDoubleStandardPhoneBundleInfo(newSelection, contractTerm) {
    const params = formFiosDataPhoneBundleInfoRequestPayload(newSelection[0]);
    const formParams = constructFormParams(params);
    try {
        const response = yield apiClient.post(GET_SELECTED_BUNDLE_INFO_URL, formParams, HeadersForFormData);
        return response.data;
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}


/* This is for UI to render with new products*/
function* getNewPlansForInternet(GET_INTERNET_URL) {
    try {
        const internetResponse = yield apiClient.get(GET_INTERNET_URL);
        yield put({ type: "GET_INTERNET_FLOW_RES", data: internetResponse.data });
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* getNewPlansForTV(GET_FIOS_TV_URL) {
    try {
        const response = yield apiClient.get(GET_FIOS_TV_URL);
        yield put({ type: "GET_FIOS_TV_RESPONSE", data: response.data });
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* getNewPlansForPhone(GET_PHONE_URL) {
    try {
        const standardPhoneResponse = yield apiClient.get(GET_PHONE_URL);
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* updateSelectedPlansForInternet(UPDATE_INTERNET_URL, allFlowRequestPayLoads, InternetType, newSelection, servicesInCart, internetProductsInCart) {

    const requestPayload = allFlowRequestPayLoads.filter(payload => payload.id === InternetType);

    requestPayload[0].selectedPlans.DataSelection = {
        //  "OldID": newSelection[0].BID.toString(),
        "NewID": newSelection[0].BID.toString()
    };

    requestPayload[0].selectedPlans.DataPlanSelection = {
        //"OldID": newSelection[0].Services[0].ID.toString(),
        "NewID": newSelection[0].Services[0].ID.toString()
    };

    const updateInternetPayload = {
        "DataSelection": requestPayload[0].selectedPlans.DataSelection,
        "DataPlanSelection": requestPayload[0].selectedPlans.DataPlanSelection,
        "RouterSelection": internetProductsInCart?.RouterSelection,
        "SelectedVASPlans": internetProductsInCart?.SelectedVASPlans,
        "SelectedPPS": internetProductsInCart?.SelectedPPS
    };


    if (servicesInCart === BUNDLE.DATA) {
        updateInternetPayload.BundleChoiceOffers = requestPayload[0].selectedPlans.BundleChoiceOffers;
        updateInternetPayload.addedbuttonSelection = requestPayload[0].selectedPlans.addedbuttonSelection;
        updateInternetPayload.ExtenderSelection = requestPayload[0].selectedPlans.ExtenderSelection;

    } else {
        updateInternetPayload.AddlDataPlanSelection = {};
        updateInternetPayload.AddlRouterSelection = { NewID: "0" };
        updateInternetPayload.InstallationSelection = internetProductsInCart?.InstallationSelection;
        updateInternetPayload.addedbuttonSelectionhsiinr = requestPayload[0].selectedPlans.addedbuttonSelectionhsiinr;
    }

    try {
        yield apiClient.post(UPDATE_INTERNET_URL, updateInternetPayload);
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* updateSelectedPlansForBDVTriple(UPDATE_INTERNET_URL, allFlowRequestPayLoads, InternetType,
    newSelection, servicesInCart, internetProductsInCart, selectedPremiumSupportPlans) {

    const requestPayload = allFlowRequestPayLoads.filter(payload => payload.id === InternetType);
    let updatedRequestPayload = {};
    if (requestPayload?.length > 0) {
        let internetModal = requestPayload[0]?.selectedPlans.fiOSDataModelPost;
        let bdvModal = requestPayload[0]?.selectedPlans.bdvModelPost;

        /* Plan update for tv - not required */
        let tvModal = requestPayload[0]?.selectedPlans.FiOSTVModelPost;

        // for data...
        internetModal.DataSelection = {
            //  "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };
        internetModal.DataPlanSelection = {
            // "OldID": newSelection[0].SpeedHCID.toString(),
            "NewID": newSelection[0].SpeedHCID.toString()
        };

        internetModal.RouterSelection = internetProductsInCart?.RouterSelection ? internetProductsInCart.RouterSelection : "";

        internetModal.SelectedPPS = getSelectedPremiumSupport(servicesInCart, selectedPremiumSupportPlans);

        // for bdv...
        bdvModal.BdvBundleSelection = {
            "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };

        // for tv
        delete tvModal?.RouterSelection;
        delete tvModal?.SelectedPPS;

        updatedRequestPayload.fiOSDataModelPost = internetModal;
        updatedRequestPayload.bdvModelPost = bdvModal;
        updatedRequestPayload.FiOSTVModelPost = tvModal;
    }
    try {
        yield apiClient.post(UPDATE_INTERNET_URL, updatedRequestPayload);
        yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
                id: InternetType,
                selectedPlans: updatedRequestPayload
            }
        });
        yield put({
            type: "UPDATE_SERVICES_IN_CART",
            params: BUNDLE.BDV_DATA_VIDEO
        });
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* updateSelectedPlansForStandardPhoneTriple(UPDATE_INTERNET_URL, allFlowRequestPayLoads, InternetType, newSelection, servicesInCart, internetProductsInCart, voiceProductsInCart, selectedPremiumSupportPlans) {

    const requestPayload = allFlowRequestPayLoads.filter(payload => payload.id === InternetType);
    let updatedRequestPayload = {};
    if (requestPayload?.length > 0) {
        let internetModal = requestPayload[0]?.selectedPlans.fiOSDataModelPost;
        let phoneModal = requestPayload[0]?.selectedPlans.voiceModelPost;

        /* Plan update for tv - not required */
        let tvModal = requestPayload[0]?.selectedPlans.FiOSTVModelPost;

        // for data...
        internetModal.DataSelection = {
            //  "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };
        internetModal.DataPlanSelection = {
            //   "OldID": newSelection[0].Services[0].ID.toString(),
            "NewID": newSelection[0].Services[0].ID.toString()
        };

        internetModal.RouterSelection = internetProductsInCart?.RouterSelection ? internetProductsInCart.RouterSelection : "";

        internetModal.SelectedPPS = getSelectedPremiumSupport(servicesInCart, selectedPremiumSupportPlans);

        // for bdv...
        phoneModal.BundleSelection = {
            "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };

        phoneModal.BatterySelected = voiceProductsInCart?.BatterySelected;

        // for tv
        delete tvModal?.RouterSelection;
        delete tvModal?.SelectedPPS;

        updatedRequestPayload.fiOSDataModelPost = internetModal;
        updatedRequestPayload.voiceModelPost = phoneModal;
        updatedRequestPayload.FiOSTVModelPost = tvModal;
    }
    try {
        yield apiClient.post(UPDATE_INTERNET_URL, updatedRequestPayload);
        yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
                id: InternetType,
                selectedPlans: updatedRequestPayload
            }
        });
        yield put({
            type: "UPDATE_SERVICES_IN_CART",
            params: BUNDLE.PHONE_DATA_VIDEO
        });
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* updateSelectedPlansForBDVDouble(UPDATE_INTERNET_URL, allFlowRequestPayLoads, InternetType,
    newSelection, servicesInCart, internetProductsInCart) {

    const requestPayload = allFlowRequestPayLoads.filter(payload => payload.id === InternetType);
    let updatedRequestPayload = {};
    if (requestPayload?.length > 0) {
        let internetModal = requestPayload[0]?.selectedPlans.fiOSDataModelPost;
        let bdvModal = requestPayload[0]?.selectedPlans.bdvModelPost;

        // for data...
        internetModal.DataSelection = {
            // "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };
        internetModal.DataPlanSelection = {
            //  "OldID": newSelection[0].SpeedHCID.toString(),
            "NewID": newSelection[0].SpeedHCID.toString()
        };
        // for bdv...
        bdvModal.BdvBundleSelection = {
            "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };

        updatedRequestPayload.fiOSDataModelPost = internetModal;
        updatedRequestPayload.bdvModelPost = bdvModal;
    }
    try {
        yield apiClient.post(UPDATE_INTERNET_URL, updatedRequestPayload);
        yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
                id: InternetType,
                selectedPlans: updatedRequestPayload
            }
        });
        yield put({
            type: "UPDATE_SERVICES_IN_CART",
            params: BUNDLE.DATA_BDV
        });
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* updateSelectedPlansForStandardPhoneDouble(UPDATE_INTERNET_URL, allFlowRequestPayLoads,
    InternetType, newSelection, servicesInCart, selectedPremiumSupportPlans) {

    const requestPayload = allFlowRequestPayLoads.filter(payload => payload.id === InternetType);
    let updatedRequestPayload = {};
    if (requestPayload?.length > 0) {
        let internetModal = servicesInCart === BUNDLE.DATA_PHONE ? requestPayload[0]?.selectedPlans.fiOSDataModelPost :
            requestPayload[0]?.selectedPlans.hsiDataModelPost;
        let phoneModal = requestPayload[0]?.selectedPlans.voiceModelPost;
        // for data...
        internetModal.DataSelection = {
            //   "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };
        internetModal.DataPlanSelection = {
            //  "OldID": newSelection[0].Services[0]?.ID.toString(),
            "NewID": newSelection[0].Services[0]?.ID.toString()
        };

        internetModal.SelectedPPS = getSelectedPremiumSupport(servicesInCart, selectedPremiumSupportPlans);

        // for bdv...
        phoneModal.BundleSelection = {
            "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };
        if (servicesInCart === BUNDLE.DATA_PHONE) {
            updatedRequestPayload.fiOSDataModelPost = internetModal;
        } else {
            updatedRequestPayload.hsiDataModelPost = internetModal;
        }
        updatedRequestPayload.voiceModelPost = phoneModal;
    }
    try {
        yield apiClient.post(UPDATE_INTERNET_URL, updatedRequestPayload);
        yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
                id: InternetType,
                selectedPlans: updatedRequestPayload
            }
        });
        if (servicesInCart === BUNDLE.DATA_PHONE) {
            yield put({
                type: "UPDATE_SERVICES_IN_CART",
                params: BUNDLE.DATA_PHONE
            });
        } else {
            yield put({
                type: "UPDATE_SERVICES_IN_CART",
                params: BUNDLE.HSI_PHONE
            });
        }
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}

function* updateSelectedPlansForFlexBundle(UPDATE_FLEX_URL, allFlowRequestPayLoads, flexInternetType, newSelection, servicesInCart, selectedPremiumSupportPlans, internetProductsInCart) {

    const requestPayload = allFlowRequestPayLoads.filter(payload => payload.id === flexInternetType);
    let updatedRequestPayload = {};

    if (requestPayload?.length > 0) {
        let internetModal = requestPayload[0]?.selectedPlans.fiOSDataModelPost;
        let tvModal = requestPayload[0]?.selectedPlans.FiOSTVModelPost;

        /* No update required for TV , as plans IDs are same */

        internetModal.DataSelection = {
            //  "OldID": newSelection[0].BID.toString(),
            "NewID": newSelection[0].BID.toString()
        };
        internetModal.DataPlanSelection = {
            //  "OldID": newSelection[0].SpeedHCID.toString(),
            "NewID": newSelection[0].SpeedHCID.toString()
        };
        internetModal.RouterSelection = internetProductsInCart?.RouterSelection ? internetProductsInCart.RouterSelection : "";
        internetModal.SelectedPPS = getSelectedPremiumSupport(servicesInCart, selectedPremiumSupportPlans);

        updatedRequestPayload.fiOSDataModelPost = internetModal;
        updatedRequestPayload.FiOSTVModelPost = tvModal;
    }

    try {
        yield apiClient.post(UPDATE_FLEX_URL, updatedRequestPayload);
        yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
                id: flexInternetType,
                selectedPlans: updatedRequestPayload
            }
        });
        yield put({
            type: "UPDATE_SERVICES_IN_CART",
            params: servicesInCart
        });
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
}
function* updateServiceRequirementCallInfo(params) {

    const { data } = params;
    const serviceCallOpt = yield select(selectors.serviceCallOpt);
    yield put({ type: "911_Service_ACCEPTED", data: true });
    const isCheckedService = serviceCallOpt === true ? 'Y' : 'N';
    
    try {
        let response = yield apiClient.post(UPDATE_SERVICES_REQ_CALL_INFO, { IsAccepted: data, IsChecked: isCheckedService});
        if (response?.data.APIStatus == "Success") {
            let serviceValue = response?.data.IsAccepted == "Y" ? true:false
            yield put({ type: "911_Service_VALUE", data: serviceValue });
            yield call(getFloatingCartDetails);
        } 
    } catch (err) {
        console.log('Catch Error', err);
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }

}

export function* switchContractActionWatcher() {
    yield takeLatest('SWITCH_CONTRACT_AGREEMENT', switchContractAgreement);
    yield takeLatest('UPDATE_SERVICES_REQ_CALL_INFO', updateServiceRequirementCallInfo);
}